export const USER_QUERY_KEYS = {
  account: ['account'],
  cognitoUser: ['cognitoUser'],
  userApiKey: ['userApiKey'],
  userData: ['userData'],
  userSettings: (isAuthenticated = false) => ['userSettings', isAuthenticated],
} as const;
